// Reduers
import { themeReducerObject } from './theme';
import { catalogueInfoReducerObject } from '../_shared/redux/catalogue';
export default {
    ...themeReducerObject,
    ...catalogueInfoReducerObject,
};
